import { Form } from 'react-router';
import { useRef } from 'react'
import Select from 'react-select'

import Button from '../Button'
import { useClickOutside } from '~/hooks/useClickOutside'
import { City, CITY_OPTIONS } from '~/utils'

import Close from '~/icons/close.svg'

const LocationModal = ({
  city,
  onClose,
}: {
  city?: City
  onClose: () => void
}) => {
  const modalRef = useRef<HTMLFormElement>(null)
  useClickOutside(modalRef, onClose)

  return (
    <Form
      ref={modalRef}
      action='/location'
      method='post'
      className='w-full flex flex-col gap-6'
      onSubmit={() => onClose()}
    >
      <div className='flex justify-between'>
        <p className='text-xl font-medium'>Select City</p>
        <button className='p-2' onClick={() => onClose()}>
          <img src={Close} alt='close' />
        </button>
      </div>
      <Select
        className='basic-single w-full mt-1 mb-6'
        classNamePrefix='select'
        isClearable
        isSearchable
        placeholder='City*'
        name='city'
        required
        options={CITY_OPTIONS}
        defaultValue={
          CITY_OPTIONS.find((option) => option.value === city) ||
          CITY_OPTIONS[0]
        }
      />
      <input type='hidden' name='page' value={window.location.pathname} />
      <div className='mt-20'>
        <Button variant='primary'>Save</Button>
      </div>
    </Form>
  )
}

export default LocationModal
